import { ApolloClient, ApolloLink, HttpLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { Auth } from '@chocolate-soup-inc/cs-api-consumer-utils';
import { AUTH_TYPE, AuthOptions, createAuthLink } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import { generatePath } from 'react-router-dom';
import { LOGIN_PATH } from '../../routes/paths';
import { cache } from './cache';

const url = import.meta.env.REACT_APP_API_URL as string;
const region = import.meta.env.REACT_APP_REGION as string;
const isProd = import.meta.env.REACT_APP_STAGE?.toLowerCase() == 'production';

const ErrorLink = onError((e: any) => {
  if (e?.networkError?.statusCode === 401 || e?.networkError?.statusCode === 403) {
    localStorage.clear();
    window.location.href = generatePath(LOGIN_PATH);
  }
});

const publicAuthOptions: AuthOptions = {
  type: AUTH_TYPE.API_KEY,
  apiKey: import.meta.env.REACT_APP_API_KEY as string
};

const privateAuthOptions: AuthOptions = {
  type: AUTH_TYPE.AWS_LAMBDA,
  token: () => {
    return Auth.currentSession().then((session) => {
      return session.getAccessToken().getJwtToken();
    });
  }
};

const httpLink = new HttpLink({ uri: url });

const publicLink = ApolloLink.from([
  createAuthLink({
    url,
    region,
    auth: publicAuthOptions
  }),
  httpLink
]);

const privateLink = ApolloLink.from([
  ErrorLink,
  createAuthLink({
    url,
    region,
    auth: privateAuthOptions
  }),
  createSubscriptionHandshakeLink(
    {
      url,
      region,
      auth: privateAuthOptions
    },
    httpLink
  )
]);

export const publicClient = new ApolloClient({
  link: publicLink,
  cache,
  connectToDevTools: true,
  name: 'public'
});

export const privateClient = new ApolloClient({
  link: privateLink,
  cache,
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache'
    }
  },
  devtools: {
    enabled: !isProd
  },
  name: 'private'
});
